// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__SxqfE","disabled":"FileBtn_disabled__2QRqQ","warn":"FileBtn_warn__7WJZP","fade":"FileBtn_fade__3Dvx2"};